// User Timing entries show up in the DevTools performance panel; jsdom lacks the API, hence the guard.
export function measureSince(name: string, start: number): void {
  if (typeof performance.measure !== "function") {
    return;
  }
  // The measure buffer is unbounded and this runs on every api request; keep only the latest entry per name
  performance.clearMeasures(name);
  performance.measure(name, { start, end: performance.now() });
}
